import {
  Input,
  Component,
  QueryList,
  AfterViewInit,
  ViewChildren,
  OnInit,
  OnDestroy,
} from '@angular/core';
import {
  Sort,
  SortDirection,
  TableColumnComponent,
} from 'marketpro-design-lib';
import { constants } from '../../../../constants';
import {
  DataFilters,
  DataFiltersService,
} from '../../services/data-filters.service';
import { StatisticsService } from '../../services/statistics.service';
import { AuthService } from '../../../auth/services/auth.service';
import { debounceTime, switchMap, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SizeOfPrize } from '../../models/statistics.model';
import { NumberLiteralType } from 'typescript';

@Component({
  selector: 'mpro-size-prize-chart',
  templateUrl: './size-of-the-prize-chart.component.html',
  styleUrls: ['./size-of-the-prize-chart.component.scss'],
})
export class SizeOfThePrizeChart implements OnInit, OnDestroy, AfterViewInit {
  @ViewChildren(TableColumnComponent)
  private cols: QueryList<TableColumnComponent>;
  private colsByProp: Map<string, TableColumnComponent> = new Map();
  public constants = constants;
  public activeChart: string = 'treemap';
  public SortDirection = SortDirection;
  public resetSortDirection: Sort = new Sort('continent', SortDirection.DESC);
  public sort: Sort = new Sort('spending_ppp', SortDirection.DESC);
  public dataFilters: DataFilters = new DataFilters();
  public currentYear: number = new Date().getFullYear();
  public selectedItemsList: string[] = ['AS', 'AF', 'EU', 'OC', 'NA'];
  private ngUnsubscribe: Subject<void> = new Subject();
  public tableData: SizeOfPrize[] = [];
  public isSOPloading = false;
  public selectedYear = this.currentYear;
  public isFreemium: boolean;
  public continentOrCountry: string;
  constructor(
    private statisticsService: StatisticsService,
    private authService: AuthService,
    private dataFiltersService: DataFiltersService
  ) {}

  public ngOnInit(): void {
    this.dataFiltersService
      .getDataFilters()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((dataFilter) => {
        this.statisticsService.getSizeOfPrize$.next();
        this.selectedYear = dataFilter.year;
      });
    this.authService.permissions$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((plan) => {
        this.isFreemium = plan.isFreemium;
        this.continentOrCountry = this.isFreemium ? 'Continent' : 'Country';
      });
    this.getSizeOfPrize();
  }

  public ngAfterViewInit(): void {
    this.cols
      .filter((c) => !!c.property)
      .forEach((c) => this.colsByProp.set(c.property, c));
  }

  private getSizeOfPrize() {
    this.statisticsService.getSizeOfPrize$
      .pipe(
        debounceTime(300),
        switchMap(() => {
          this.isSOPloading = true;
          return this.statisticsService.getSizeOfPrize();
        })
      )
      .subscribe((response) => {
        this.isSOPloading = false;
        this.tableData = response.map((r) => ({
          ...r,
          year: this.selectedYear,
        }));
      });
  }

  fetchSelectedItems() {
    this.selectedItemsList = this.constants.legendItems
      .filter((value) => value.isChecked)
      .map((item) => item.code);
  }

  public handleClick(id) {
    if (id !== this.activeChart) {
      this.activeChart = id;
    }
  }

  public onSort(sort: Sort) {
    this.resetSortDirection.property =
      sort.property === 'continent' ? 'spending_ppp' : 'continent';
    this.tableData.sort((c1, c2) => {
      if (sort.property === 'continent') {
        if (c1.continentName < c2.continentName) {
          return sort.direction === 2 ? 1 : -1;
        }
        if (c1.continentName > c2.continentName) {
          return sort.direction === 2 ? -1 : 1;
        }
        return 0;
      }
      if (c1.totalAmount < c2.totalAmount) {
        return sort.direction === 2 ? 1 : -1;
      }
      if (c1.totalAmount > c2.totalAmount) {
        return sort.direction === 2 ? -1 : 1;
      }
      return 0;
    });
    this.sort = sort;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
